export default "/img/PW.29c3aadb7a04cda25def58eacc1a9a83.png";